// extracted by mini-css-extract-plugin
export default {"component":"MarketHeader_component__Zw2dw"};